import React from "react";
import { Box, Checkbox, ListItem, ListItemButton, ListItemText, Typography, Stack, Button, FormControlLabel } from "@mui/material";

const weekdays = [
    { title: "Monday", value: "Monday" },
    { title: "Tuesday", value: "Tuesday" },
    { title: "Wednesday", value: "Wednesday" },
    { title: "Thursday", value: "Thursday" },
    { title: "Friday", value: "Friday" },
    { title: "Saturday", value: "Saturday" },
    { title: "Sunday", value: "Sunday" },
];

const weekendDays = ["Thursday", "Friday", "Saturday"];

export default function WeekdayList({ changeHandler, inputValue = [], setOpen }) {
    // Ensure inputValue is an array
    const selectedValues = Array.isArray(inputValue) ? inputValue : [];

    const handleToggle = (day) => {
        const currentIndex = selectedValues.findIndex(item => item.value === day.value);
        const newChecked = [...selectedValues];

        if (currentIndex === -1) {
            newChecked.push(day);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        changeHandler({ ruleValue: newChecked });
    };

    const handleWeekendToggle = (e) => {
        if (e.target.checked) {
            // Select Thursday, Friday, Saturday
            const newSelections = weekdays.filter(day => weekendDays.includes(day.value));
            changeHandler({ ruleValue: newSelections });
        } else {
            // Clear selections
            changeHandler({ ruleValue: [] });
        }
    };

    const isWeekendSelected = (() => {
        if (selectedValues.length === 0) return false;
        return weekendDays.every(dayValue =>
            selectedValues.some(item => item.value === dayValue)
        );
    })();

    return (
        <Box sx={{ p: 2, minWidth: 280 }} onClick={(e) => e.stopPropagation()}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#333' }}>
                    Select Weekdays
                </Typography>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={isWeekendSelected}
                            onChange={handleWeekendToggle}
                            sx={{ p: 0.5 }}
                        />
                    }
                    label={<Typography variant="caption" sx={{ fontWeight: 'bold' }}>Weekend</Typography>}
                    sx={{ mr: 0 }}
                />
            </Box>

            <Box sx={{ maxHeight: 300, overflow: "auto", mb: 2 }}>
                {weekdays.map((day) => {
                    const isChecked = selectedValues.some(item => item.value === day.value);
                    return (
                        <ListItem key={day.value} disablePadding sx={{ mb: 0.2 }}>
                            <ListItemButton
                                onClick={() => handleToggle(day)}
                                sx={{
                                    borderRadius: '6px',
                                    py: 0.5,
                                    '&.Mui-selected': {
                                        bgcolor: 'rgba(71, 92, 199, 0.08)',
                                    },
                                    '&:hover': {
                                        bgcolor: 'rgba(0, 0, 0, 0.04)',
                                    }
                                }}
                                selected={isChecked}
                            >
                                <Checkbox
                                    checked={isChecked}
                                    edge="start"
                                    disableRipple
                                    size="small"
                                    sx={{ p: 0.5, mr: 1 }}
                                />
                                <ListItemText
                                    primary={
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: isChecked ? 'bold' : 'normal',
                                                fontSize: '13px',
                                                color: isChecked ? 'primary.main' : '#444'
                                            }}
                                        >
                                            {day.title}
                                        </Typography>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                    );
                })}
            </Box>

            <Button
                variant="contained"
                size="medium"
                onClick={() => setOpen && setOpen(false)}
                fullWidth
                sx={{
                    textTransform: 'none',
                    fontWeight: 'bold',
                    boxShadow: 'none',
                    '&:hover': { boxShadow: 'none' }
                }}
            >
                Done
            </Button>
        </Box>
    );
}
